import { useEffect } from 'react';

/**
 * La réinitialisation de mot de passe se fait sur l'admin (SSO partagé).
 */
export default function ForgotPassword() {
  useEffect(() => {
    const adminUrl =
      (import.meta.env.VITE_URL_ADMIN as string | undefined)?.replace(/\/$/, '') || 'http://localhost:5231';
    window.location.replace(`${adminUrl}/forgot-password?fromSource=site`);
  }, []);

  return null;
}
